// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Google = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Google = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Google = _exports.Google = function Google(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M18.8 10.207C18.8 9.55703 18.7417 8.93203 18.6333 8.33203H10V11.882H14.9333C14.7167 13.0237 14.0667 13.9904 13.0917 14.6404V16.9487H16.0667C17.8 15.3487 18.8 12.9987 18.8 10.207Z",
      fill: "#4285F4"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.99974 19.1667C12.4747 19.1667 14.5497 18.35 16.0664 16.95L13.0914 14.6417C12.2747 15.1917 11.2331 15.525 9.99974 15.525C7.61641 15.525 5.59141 13.9167 4.86641 11.75H1.81641V14.1167C3.32474 17.1083 6.41641 19.1667 9.99974 19.1667Z",
      fill: "#34A853"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M4.86537 11.7406C4.68203 11.1906 4.5737 10.6073 4.5737 9.99896C4.5737 9.39062 4.68203 8.80729 4.86537 8.25729V5.89062H1.81536C1.19036 7.12396 0.832031 8.51562 0.832031 9.99896C0.832031 11.4823 1.19036 12.874 1.81536 14.1073L4.19036 12.2573L4.86537 11.7406Z",
      fill: "#FBBC05"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.99974 4.48203C11.3497 4.48203 12.5497 4.9487 13.5081 5.8487L16.1331 3.2237C14.5414 1.74036 12.4747 0.832031 9.99974 0.832031C6.41641 0.832031 3.32474 2.89036 1.81641 5.89036L4.86641 8.25703C5.59141 6.09036 7.61641 4.48203 9.99974 4.48203Z",
      fill: "#EA4335"
    }));
  };
});
